'use client';
import { createStyles, getSize } from '@s7/styles';

var spacings = {
    xs1: 2,
    sm1: "1s",
    md1: "1s"
};
var useStyles = createStyles(function(theme, param, param1) {
    var spacing = param.spacing;
    var size = param1.size;
    return {
        root: {
            "& > * + *": {
                marginTop: theme.fn.space(getSize({
                    size: spacing != null ? spacing : size,
                    sizes: spacings
                }))
            }
        }
    };
});

export { useStyles as default };
